import { markLanguageChoicePending } from '@/utils/language-choice';
import { setLocalStorage } from '@/local-storage/utils';
import { useTranslation } from 'react-i18next';

export const LandingLanguageSelector = () => {
  const { i18n } = useTranslation();

  return (
    <div
      className="cursor-pointer text-2xl opacity-80 hover:opacity-100"
      onClick={() => {
        const newLanguage = i18n.language === 'en' ? 'nl' : 'en';

        setLocalStorage('language', newLanguage);
        // sent to the backend once the person is signed in
        markLanguageChoicePending(newLanguage);
        i18n.changeLanguage(newLanguage);
      }}
    >
      {i18n.language === 'en' ? '🇳🇱' : '🇬🇧'}
    </div>
  );
};
